import {
  AdminprofileImage,
  TableComponent,
  Navbar,
  Text,
  Btn,
} from '../../components/index';
import { IoIosArrowForward } from 'react-icons/io';
import Loader from '../../components/loader';
import SingleProjectFunction from './index.function';
import { fontSizes } from '../../constants/constants';
const ProjectDetailsPage = () => {
  const {
    isLoading,
    quantityReport,
    materialReport,
    costingReport,
    materialStatusReport,
    costingStatusReport,
    isprojectMaterial,
    // isprojectCost,
    loadingToapi,
    projectQuantity,
    projectMaterial,
    projectCost,
    createMaterialReport,
    // createCostingReport,
    handleCostingReport,
    openCostingReport,
    ProjectData,
    navigate,
    TextWeight,
    projectID,
    setCostingReport,
    setCostingStatusReport,
  } = SingleProjectFunction();

  return (
    <div className='flex'>
      <Navbar />
      <div className='w-full px-4 py-7 lg:px-12 lg:py-10 h-screen overflow-y-scroll hide-scrollbar'>
        <AdminprofileImage
          onBack={() => {
            navigate('/status');
          }}
          title={`Project: ${ProjectData?.data?.name || ''}`}
        />
        <div>
          {projectQuantity?.map((section, index) => (
            <TableComponent
              key={index}
              title={`${section?.title}`}
              description={section?.description}
              columns={section?.columns}
              isLoading={isLoading}
              data={quantityReport}
              buttons={section?.buttons}
              navigateBtn={section?.navigateBtn}
              continueButton={section?.continueButton}
            />
          ))}
          <div className='pt-1 lg:pt-3'>
            {isprojectMaterial ? (
              <>
                {projectMaterial?.map((section, index) => (
                  <TableComponent
                    key={index}
                    title={`${section?.title}`}
                    description={section?.description}
                    columns={section?.columns}
                    data={materialReport}
                    isLoading={isLoading}
                    buttons={section?.buttons}
                    navigateBtn={section?.navigateBtn}
                    continueButton={section?.continueButton}
                  />
                ))}
              </>
            ) : (
              <div
                className={`${
                  materialStatusReport === 'IN_PROGRESS' ||
                  materialStatusReport === 'FAILED' ||
                  materialStatusReport === 'IN PROGRESS'
                    ? 'flex justify-between  w-full items-center'
                    : ''
                }`}
              >
                {materialStatusReport === 'IN_PROGRESS' ||
                materialStatusReport === 'FAILED' ||
                materialStatusReport === 'IN PROGRESS' ? (
                  <Text
                    text={'Material Report'}
                    size={fontSizes.h30}
                    weight={TextWeight.Raleway_ExtraBold}
                    color='text-black'
                    isTruncate={false}
                  />
                ) : (
                  ''
                )}
                <div
                  className={`${
                    materialStatusReport === 'IN_PROGRESS' ||
                    materialStatusReport === 'IN PROGRESS' ||
                    materialStatusReport === 'FAILED'
                      ? ''
                      : 'w-full flex justify-end items-center'
                  } gap-x-5 py-4`}
                >
                  <button
                    className={`flex items-center px-3 lg:px-6 lg:py-3 shadow-custom-gray rounded-xl ${
                      materialStatusReport === 'FAILED' ||
                      materialStatusReport === 'IN PROGRESS' ||
                      materialStatusReport === 'IN_PROGRESS' ||
                      loadingToapi
                        ? 'opacity-80'
                        : ''
                    } flex-row`}
                    onClick={createMaterialReport}
                    disabled={
                      materialStatusReport === 'FAILED' ||
                      materialStatusReport === 'IN PROGRESS' ||
                      materialStatusReport === 'IN_PROGRESS' ||
                      loadingToapi
                    }
                  >
                    <p
                      className={`font-ralewayBold ${
                        materialStatusReport === 'IN_PROGRESS' ||
                        materialStatusReport === 'FAILED' ||
                        materialStatusReport === 'IN PROGRESS'
                          ? ''
                          : 'mr-3 lg:mr-5'
                      } `}
                    >
                      {materialStatusReport
                        ? materialStatusReport === 'IN_PROGRESS'
                          ? 'IN PROGRESS'
                          : materialStatusReport
                        : 'Generate Material Report'}
                    </p>
                    {loadingToapi ? (
                      <Loader isprimary={true} />
                    ) : (
                      <>
                        {materialStatusReport === 'IN_PROGRESS' ||
                        materialStatusReport === 'FAILED' ||
                        materialStatusReport === 'IN PROGRESS' ? (
                          ''
                        ) : (
                          <div className='bg-primary rounded-sm p-[1px] lg:p-[2px]'>
                            <p className={`text-secondary text-sm rotate-90`}>
                              <IoIosArrowForward />
                            </p>
                          </div>
                        )}
                      </>
                    )}
                  </button>
                </div>
              </div>
            )}
          </div>
          <div className='pt-1 lg:pt-3'>
            {openCostingReport
              ? projectCost?.map((section, index) => (
                  <TableComponent
                    key={index}
                    title={section?.title}
                    description={section?.description}
                    columns={section?.columns}
                    data={
                      costingStatusReport === 'COMPLETED'
                        ? costingReport
                        : materialReport
                    }
                    handleCostingReport={handleCostingReport}
                    openCostingReport={openCostingReport}
                    isLoading={isLoading}
                    buttons={section?.buttons}
                    navigateBtn={section?.navigateBtn}
                    continueButton={section?.continueButton}
                    projectID={projectID}
                    costingStatusReport={costingStatusReport}
                    materialStatusReport={materialStatusReport}
                    setCostingReport={setCostingReport}
                    setCostingStatusReport={setCostingStatusReport}
                  />
                ))
              : materialStatusReport === 'COMPLETED' && (
                  <div className='w-full flex justify-end items-center pt-4'>
                    {openCostingReport ? (
                      ''
                    ) : (
                      <Btn
                        type={'button'}
                        isprimary={false}
                        weight={TextWeight.Raleway_SemiBold}
                        textSize={fontSizes.h18}
                        className='!px-11 !py-3'
                        text={'Generate Report'}
                        color='text-white'
                        onClick={handleCostingReport}
                        hover={
                          'hover:text-primary hover:bg-white hover:border-primary'
                        }
                        bgColor={'bg-primary border-transparent'}
                      />
                    )}
                  </div>
                )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetailsPage;
